var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c(_vm.currentProgress,{tag:"component"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"pagettl"}},[_c('h1',[_vm._v("お問い合わせ")])])}]

export { render, staticRenderFns }